import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PopularPlaceRequestBody, PopularPlaceResponse } from "./types";

export class PopularPlaceAPI extends BaseAPI<
    PopularPlaceRequestBody,
    PopularPlaceResponse
> {
    protected route = ApiRoutes.search.popular_place;
    protected method = RequestMethod.GET;
}